import { AfterViewInit, Component, DestroyRef } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { timer } from 'rxjs';
import { RouterLink } from '@angular/router';
import { NotificationAlert } from '@app/pages/notifications/models/notification.model';
import { NotificationsStore } from '@app/pages/notifications/store/notifications.store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-alert',
  imports: [NgClass, DatePipe, RouterLink, TranslatePipe],
  templateUrl: './notification-alert.component.html',
  styleUrl: './notification-alert.component.scss'
})
export class NotificationAlertComponent implements AfterViewInit {
  public isAlertNotification = true;

  public messagesListAlert: NotificationAlert[] = [];

  constructor(
    private notificationsStore: NotificationsStore,
    private destroyRef: DestroyRef
  ) {}

  ngAfterViewInit() {
    this.streamToNotificationsAlert();
  }

  private streamToNotificationsAlert(): void {
    this.notificationsStore.notificationsListsAlert$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data?.length) {
          data.forEach(newNotification => {
            if (
              !this.messagesListAlert.some(
                msg => msg.userId === newNotification.userId
              )
            ) {
              this.messagesListAlert = [
                ...this.messagesListAlert,
                newNotification
              ];

              timer(3000).subscribe(() => {
                this.removeNotification(newNotification.userId);
              });
            }
          });
        }
      });
  }

  private removeNotification(id: string): void {
    const index = this.messagesListAlert.findIndex(
      message => message.userId === id
    );

    if (index > -1) {
      this.messagesListAlert[index].hidden = true;

      timer(500).subscribe(() => {
        this.messagesListAlert = this.messagesListAlert.filter(
          message => message.userId !== id
        );
      });
    }
  }
}
